import React, { useState } from 'react';
import GraphqlTable from 'cccisd-graphql-table';
import studentsQuery from './students.graphql';
import classesQuery from './classes.graphql';
import style from './style.css';

const Fortress = window.cccisd.fortress;

const NominationsTab = ({ timepointOptions }) => {
    const actingRole = Fortress.user.acting.role.handle;
    const [currView, setCurrView] = useState('students');

    function percentRender({ value }) {
        if (value === null) {
            return <span>-</span>;
        }

        const val = Number(value);
        if ((!val && val !== 0) || !Number.isFinite(val)) {
            return;
        }

        const percentage = Math.round(val * 100);
        return <span>{percentage}%</span>;
    }

    const studentNominationColumns = timepointOptions.reduce((cols, tp) => {
        cols.push({
            name: `tp${tp}.devTags.pn_spendtime_oneway_in`,
            label: `Time ${tp} - In`,
            tooltip: 'The number of other students who nominated this student.',
            sort: true,
            filter: true,
            className: `${style.timeColumnsStart} text-center`,
        });
        cols.push({
            name: `tp${tp}.devTags.pn_spendtime_oneway_out`,
            label: `Time ${tp} - Out`,
            tooltip: 'The number of other students this student nominated.',
            sort: true,
            filter: true,
            className: 'text-center',
        });
        cols.push({
            name: `tp${tp}.devTags.pn_spendtime_twoway`,
            label: `Time ${tp} - Two-Way`,
            tooltip: 'The number of times this student nominated someone who also nominated them.',
            sort: true,
            filter: true,
            className: `${style.timeColumnsEnd} text-center`,
        });
        return cols;
    }, []);

    const classNominationColumns = timepointOptions.reduce((cols, tp) => {
        cols.push({
            label: `Time ${tp} % of Possible Nominations`,
            name: `descendantRoles.tp${tp}.assignmentProgress.devTags.pn_spendtime_classwide_pcnt`,
            render: percentRender,
            filter: true,
            sort: true,
            className: 'text-center',
        });
        return cols;
    }, []);

    let columns;
    let query;
    let rowKey;
    switch (currView) {
        case 'students':
            rowKey = 'pawn.pawnId';
            query = studentsQuery;
            columns = [
                {
                    name: 'fields.studentId',
                    label: 'Student ID',
                    sort: true,
                    filter: true,
                },
                {
                    name: 'user.firstName',
                    label: 'First Name',
                    sort: true,
                    filter: true,
                },
                {
                    name: 'user.lastName',
                    label: 'Last Name',
                    sort: true,
                    filter: true,
                },
                {
                    name: 'ancestorGroups.class.group.label',
                    label: 'Class',
                    sort: true,
                    filter: true,
                },
                ...studentNominationColumns,
            ];

            if (
                ['guAdmin', 'uberadmin'].includes(actingRole) &&
                !columns.some(col => col.name === 'ancestorGroups.site.group.label')
            ) {
                columns.splice(3, 0, {
                    name: 'ancestorGroups.site.group.label',
                    label: 'School',
                    sort: true,
                    filter: true,
                });
            }

            break;

        case 'classes':
            rowKey = 'group.groupId';
            query = classesQuery;
            columns = [
                {
                    label: 'Class',
                    name: 'group.label',
                    filter: true,
                    sort: true,
                },
                {
                    label: 'Teacher',
                    name: 'targetedByPawns.instructorList',
                    render: ({ value }) =>
                        value && (
                            <ul className={style.instructorList}>
                                {value.map(teacher => (
                                    <li key={teacher.user.fullName}>{teacher.user.fullName}</li>
                                ))}
                            </ul>
                        ),
                    filter: true,
                    filterSettings: {
                        type: 'text',
                        field: 'targetedByPawns.instructor.user.fullName',
                    },
                    sort: false,
                },
                {
                    label: 'Active Students',
                    name: 'descendantRoles.learnerCount',
                    filter: false,
                    sort: true,
                    className: 'text-center',
                },
                ...classNominationColumns,
            ];
            if (
                ['guAdmin', 'uberadmin'].includes(actingRole) &&
                !columns.some(col => col.name === 'ancestorGroups.site.group.label')
            ) {
                columns.splice(1, 0, {
                    name: 'parentGroup.site.group.label',
                    label: 'School',
                    sort: true,
                    filter: true,
                });
            }

            break;
        default:
            break;
    }

    return (
        <div>
            <select
                className={'form-select mb-5 ' + style.viewSelector}
                id="data_view"
                name="data_view"
                value={currView}
                onChange={e => setCurrView(e.target.value)}
            >
                <option value="students">Students</option>
                <option value="classes">Classes</option>
            </select>
            <GraphqlTable
                key={currView}
                isStickyHeader
                showDoubleScrollbar
                query={query}
                columns={columns}
                rowKey={rowKey}
            />
        </div>
    );
};

export default NominationsTab;
